import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Link } from '@shopify/polaris';

const propTypes = {
  url: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
}

const defaultProps = {

}

const ItemLink = ({ url, content }) => (
  <Link external url={url} removeUnderline>{ content }</Link>
)

ItemLink.propTypes = propTypes;
ItemLink.defaultProps = defaultProps;

export default ItemLink;